import React, { Component } from 'react';
import { Redirect, Route } from 'react-router'
import { Col, Grid, Row, Button } from 'react-bootstrap';
import MenuPrincipal from './MenuPrincipal';
import MenuFinal from './MenuFinal';
import { LinkContainer } from 'react-router-bootstrap';
import '../css/Global.css';

export class Retro extends Component {
    constructor(props) {
        super(props);
        var cadena = window.location.search.toUpperCase();
        var valores = [];
        if (cadena.indexOf("&") === -1) {
            valores.push(cadena);
        } else {
            valores = cadena.split('&');
        }



        var final = "/";
        for (let i = 0; i < valores.length; i++) {
            if (valores[i].startsWith("CARRERA") || valores[i].startsWith("?CARRERA")) {
                var valor = valores[i].split("=")[1];
                switch (valor) {
                    case "DCEN":
                        final = '/Doctorado/Pedagogia';
                        break;

                    case "MCSN":
                        final = '/Maestria/Sociologia_Educativa';
                        break;

                    case "MEDN":
                        final = '/Maestria/Educacion_Especial';
                        break;

                    case "ENT":
                        final = '/Maestria/Educacion_Especial';
                        break;

                    case "ECE":
                        final = '/Maestria/Educacion_Especial';
                        break;

                    case "SEPEIR":
                        final = '/Maestria/Educacion_Especial';
                        break;

                    case "IRO":
                        final = '/Ingenieria/Robotica';
                        break;

                    case "ICA":
                        final = '/Ingenieria/Control_y_Automatizacion';
                        break;

                    case "LFL":
                        final = '/Licenciatura/Filologia_y_Literatura';
                        break;

                    case "LEC":
                        final = '/Licenciatura/Economia';
                        break;

                    case "LSE":
                        final = '/Licenciatura/Sociologia_Educacion';
                        break;

                    case "LSP":
                        final = '/Licenciatura/Sociologia_Politica';
                        break;

                    case "LCPL":
                        final = '/Licenciatura/Contaduria_Publica';
                        break;

                    case "LAEL":
                        final = '/Licenciatura/Administracion_de_Empresas';
                        break;

                    case "LPS":
                        final = '/Licenciatura/Psicologia_Social';
                        break;



                }
            }
        }
        this.state = {url: final}

    }

    render() {
        return (
            <Route>
                <Redirect to={this.state.url} />
            </Route>

        )
    }
}
export default Retro;


// WEBPACK FOOTER //
// ./src/components/Retro.js